export const TypeRedux = {
  LOGIN: 'LOGIN',
}
